<template>
    <tr>
        <td class="px-6 py-4 whitespace-nowrap hidden">
            <div class="flex-shrink-0 h-6 w-6 items-center">
                <input
                    type="checkbox"
                    class="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    v-model="meeting.checked"
                />
            </div>
        </td>
        <td class="px-6 py-4 whitespace-yeswrap">
            <div class="text-sm font-medium text-gray-900">
                {{ meeting.title }}
            </div>
            <p
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
                v-if="meeting.role"
            >
                {{ meeting.role }}
            </p>
        </td>
        <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900 capitalize">
                {{ meeting.date }}
            </div>
            <div class="text-sm text-gray-500">
                {{
                    t("meeting.start-time", "Aanvang: :value uur", meeting.time)
                }}
            </div>
        </td>
        <td class="px-6 py-4 whitespace-nowrap">
            <Menu
                as="div"
                class="relative inline-block text-left"
                @click="setFullHeightTable()"
            >
                <div @click="setFullHeightTable()">
                    <MenuButton
                        @click="setFullHeightTable()"
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                    >
                        {{ t("options", "Opties") }}
                        <ChevronDownIcon
                            class="-mr-1 ml-2 h-5 w-5"
                            aria-hidden="true"
                            @click="setFullHeightTable()"
                        />
                    </MenuButton>
                </div>

                <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                >
                    <MenuItems
                        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none z-50"
                    >
                        <div
                            class="px-4 py-3 bg-indigo-50 text-center"
                            v-if="meeting.room"
                        >
                            <p class="text-sm font-bold pb-1">
                                {{ t("meeting.statistics", "Statistieken") }}
                            </p>
                            <p
                                class="text-sm text-gray-900 truncate mb-1"
                                v-if="meeting.room.chats"
                            >
                                <span
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm bg-indigo-200 text-indigo-800"
                                >
                                    {{ t("meeting.chats", "Chats") }}
                                    <span class="font-medium ml-1">{{
                                        meeting.room.chats.length
                                    }}</span>
                                </span>
                            </p>

                            <p
                                class="text-sm text-gray-900 truncate mb-1"
                                v-if="
                                    meeting.room.polls &&
                                    meeting.room.polls.length > 0
                                "
                            >
                                <span
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm bg-indigo-200 text-indigo-800"
                                >
                                    {{ t("meeting.polls", "Stemmingen") }}
                                    <span class="font-medium ml-1">{{
                                        meeting.room.polls.length
                                    }}</span>
                                </span>
                            </p>

                            <p
                                class="text-sm text-gray-900 truncate mb-1"
                                v-if="meeting.status == 'past'"
                            >
                                <span
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm bg-indigo-200 text-indigo-800"
                                >
                                    {{ t("meeting.attendees", "Deelnemers") }}
                                    <span class="font-medium ml-1">{{
                                        meeting.active_users > 0
                                            ? meeting.active_users
                                            : meeting.attendees
                                    }}</span>
                                </span>
                            </p>
                        </div>
                        <div class="py-1">
                            <MenuItem v-slot="{ active }" v-if="meeting.room">
                                <router-link
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                    :to="{
                                        name: 'meetings-edit',
                                        params: {
                                            id: meeting.hash,
                                            time: timestamp,
                                        },
                                    }"
                                    replace
                                    >{{
                                        t("meeting.edit", "Bewerken")
                                    }}</router-link
                                >
                            </MenuItem>

                            <MenuItem v-slot="{ active }" v-if="meeting.room">
                                <router-link
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                    :to="{
                                        name: 'meetings-polls',
                                        params: {
                                            id: meeting.room.slug,
                                            time: timestamp,
                                        },
                                    }"
                                    replace
                                    >{{
                                        t(
                                            "meeting.poll-results",
                                            "Resultaten stemming",
                                        )
                                    }}</router-link
                                >
                            </MenuItem>
                            <MenuItem v-slot="{ active }" v-if="meeting.room">
                                <router-link
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                    :to="{
                                        name: 'meetings-documents',
                                        params: {
                                            id: meeting.hash,
                                            time: timestamp,
                                        },
                                    }"
                                    replace
                                    >{{
                                        t("meeting.documents", "Documenten")
                                    }}</router-link
                                >
                            </MenuItem>
                        </div>
                        <div class="py-1" v-if="meeting.status == 'future'">
                            <MenuItem v-slot="{ active }">
                                <p
                                    @click="actionForSelection('send-invite')"
                                    class="cursor-pointer"
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                >
                                    {{
                                        t(
                                            "meeting.send-invites",
                                            "Stuur uitnodigingen",
                                        )
                                    }}
                                </p>
                            </MenuItem>

                            <MenuItem
                                v-slot="{ active }"
                                v-if="
                                    meeting.room && meeting.status == 'future'
                                "
                            >
                                <router-link
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                    :to="{
                                        name: 'meetings-poll-concepts',
                                        params: {
                                            id: meeting.room.slug,
                                            time: timestamp,
                                        },
                                    }"
                                    replace
                                    >{{
                                        t(
                                            "meeting.poll-concepts",
                                            "Stemmingen klaarzetten",
                                        )
                                    }}</router-link
                                >
                            </MenuItem>
                        </div>
                        <div class="py-1" v-if="meeting.status == 'past'">
                            <MenuItem v-slot="{ active }">
                                <p
                                    @click="actionForSelection('export')"
                                    class="cursor-pointer"
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                >
                                    {{
                                        t(
                                            "meeting.generate-export",
                                            "Export genereren",
                                        )
                                    }}
                                </p>
                            </MenuItem>

                            <MenuItem
                                v-slot="{ active }"
                                v-if="meeting.status == 'past'"
                            >
                                <p
                                    @click="actionForSelection('recording')"
                                    class="cursor-pointer"
                                    :class="[
                                        active
                                            ? 'bg-gray-100 text-gray-900'
                                            : 'text-gray-700',
                                        'block px-4 py-2 text-sm',
                                    ]"
                                >
                                    {{
                                        t(
                                            "meeting.download-recording",
                                            "Opname downloaden",
                                        )
                                    }}
                                </p>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </transition>
            </Menu>
        </td>

        <td
            class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium hidden"
        >
            <router-link
                :to="{
                    name: 'meetings-edit',
                    params: {
                        id: meeting.hash,
                        time: timestamp,
                    },
                }"
                replace
                class="cursor-pointer text-blue-600 hover:text-blue-900"
            >
                <PencilAltIcon
                    class="h-5 w-5 text-blue-600 hover:text-blue-900"
                    aria-hidden="true"
                />
            </router-link>
        </td>
    </tr>
</template>

<script>
import {
    DotsCircleHorizontalIcon,
    PencilAltIcon,
} from "@heroicons/vue/outline";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import Swal from "sweetalert2";
export default {
    mounted() {
        this.timestamp = new Date().getTime();
        Eventing.listen(
            "formMeeting",
            () => (this.timestamp = new Date().getTime()),
        );
    },
    created() {},
    components: {
        PencilAltIcon,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronDownIcon,
        DotsCircleHorizontalIcon,
    },
    props: ["meeting"],
    data() {
        return {
            timestamp: "ts",
            list: "active",
        };
    },
    methods: {
        getTimeStamp() {
            return new Date().getTime();
        },
        setFullHeightTable() {
            Eventing.fire("tableFullHeight");
        },
        actionForSelection(_action) {
            let self = this;

            var title = self.t("meeting.actions.title", "Let op"); // "Let op";
            var text = self.t("meeting.actions.are-you-sure", "Zeker weten:"); //"Zeker weten: ";
            var action = _action;
            switch (_action) {
                case "send-invite":
                    text = self.t(
                        "meeting.actions.send-invite-text",
                        "Zeker weten dat je de actieve deelnemers voor deze vergadering wilt ",
                    );
                    action = self.t(
                        "meeting.actions.send-invite-action",
                        "uitnodigen",
                    );
                    break;
                case "recording":
                    action = self.t(
                        "meeting.actions.recording-action",
                        "Opname downloaden",
                    );
                    break;
                case "export":
                    text = self.t(
                        "meeting.actions.export-text",
                        "Starten van ",
                    );
                    action = self.t("meeting.actions.export-action", "export");
                    // text = "Starten van ";
                    // action = "export";
                    break;
                default:
                    break;
            }

            Swal.fire({
                title: title,
                text: text + " " + action + "?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    if (_action == "export") {
                        axios({
                            url: "/api/meeting-actions",
                            method: "POST",
                            // responseType: "blob",
                            data: {
                                meeting: self.meeting.hash,
                                action: _action,
                            },
                        })
                            .then((response) => {
                                var url = window.URL.createObjectURL(
                                    new Blob([response.data]),
                                );

                                if (response.data.url) {
                                    url = response.data.url;
                                }
                                // const url = window.URL.createObjectURL(
                                //     new Blob([response.data]),
                                // );

                                Eventing.fire("fetchMeetings");

                                const link = document.createElement("a");

                                link.href = url;
                                link.setAttribute(
                                    "download",
                                    "Export " + self.meeting.datum + ".xlsx",
                                );
                                document.body.appendChild(link);
                                link.click();

                                Eventing.fire("notify", {
                                    title: self.capitalize(action),
                                    message: self.t(
                                        "meeting.actions.download-started",
                                        "Download is gestart",
                                    ),
                                    type: "success",
                                    position: "center",
                                });
                            })
                            .catch((error) => {
                                Eventing.fire("fetchMeetings");
                            });
                    } else if (_action == "recording") {
                        axios({
                            url: "/api/meeting-actions",
                            method: "POST",
                            // responseType: "blob",
                            data: {
                                meeting: self.meeting.hash,
                                action: _action,
                            },
                        })
                            .then((response) => {
                                if (response.status == 200) {
                                    Eventing.fire("fetchMeetings");

                                    const link = document.createElement("a");
                                    // alert(JSON.stringify(response.data));
                                    var url = response.data;
                                    // alert(JSON.stringify(url));
                                    link.href = url;
                                    link.setAttribute(
                                        "download",
                                        "Video " + self.meeting.datum + ".mp4",
                                    );
                                    document.body.appendChild(link);
                                    link.click();
                                    Eventing.fire("notify", {
                                        title: self.capitalize(action),
                                        message: self.t(
                                            "meeting.actions.download-started",
                                            "Download is gestart",
                                        ),
                                        type: "success",
                                        position: "center",
                                    });
                                    return (window.location = url);
                                } else {
                                    const url = window.URL.createObjectURL(
                                        new Blob([response.data]),
                                    );

                                    Eventing.fire("fetchMeetings");

                                    const link = document.createElement("a");

                                    link.href = url;
                                    link.setAttribute(
                                        "download",
                                        "Export " + self.meeting.datum + ".zip",
                                    );
                                    document.body.appendChild(link);
                                    link.click();

                                    Eventing.fire("notify", {
                                        title: self.capitalize(action),
                                        message: self.t(
                                            "meeting.actions.download-started",
                                            "Download is gestart",
                                        ),
                                        type: "success",
                                        position: "center",
                                    });
                                }
                            })
                            .catch((error) => {
                                Eventing.fire("fetchMeetings");
                                if (error.response.status == 422) {
                                    Eventing.fire("notify", {
                                        title: self.t(
                                            "meeting.actions.failed",
                                            "Mislukt",
                                        ),
                                        message: self.t(
                                            "meeting.actions.no-recordings",
                                            "Geen opnames bekend",
                                        ),
                                        type: "error",
                                    });
                                }
                            });
                    } else {
                        axios
                            .post("/api/meeting-actions", {
                                meeting: self.meeting.hash,
                                action: _action,
                            })
                            .then((response) => {
                                Eventing.fire("notify", {
                                    title: self.capitalize(action),
                                    message: self.t(
                                        "meeting.actions.success",
                                        "Actie succesvol uitgevoerd",
                                    ),
                                    type: "success",
                                    position: "center",
                                });
                                Eventing.fire("fetchMeetings");
                            })
                            .catch((error) => {});
                    }
                }
            });
        },
        capitalize(s) {
            return s[0].toUpperCase() + s.slice(1);
        },
    },
};
</script>
